import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';

function NavLink({ to, icon, label, onNavigate }) {
  const { pathname } = useLocation();
  const active = pathname === to || pathname.startsWith(to + '/');
  return (
    <Link to={to} className={`sidebar-link${active ? ' active' : ''}`} onClick={onNavigate}>
      <span className="sidebar-icon">{icon}</span>
      <span className="sidebar-label">{label}</span>
    </Link>
  );
}

export default function Sidebar({ onNavigate }) {
  const { user } = useAuth();
  const role = user?.role;
  const L = (props) => <NavLink {...props} onNavigate={onNavigate} />;

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <Logo className="sidebar-logo-img" fallbackClassName="logo-icon" />
        <span className="logo-text">TaskTool</span>
      </div>

      <nav className="sidebar-nav">
        {role === 'employee' && (
          <>
            <L to="/employee/dashboard" icon="▦" label="Dashboard" />
            <L to="/employee/tasks" icon="✓" label="My Tasks" />
            <L to="/employee/issues" icon="⚠" label="Issues" />
            <L to="/employee/concerns" icon="✉" label="Concerns" />
            <L to="/employee/leaves" icon="📅" label="Leave Requests" />
            <L to="/employee/timesheet" icon="🕒" label="My Timesheet" />
            <L to="/employee/feedback" icon="💬" label="Feedback" />
            <L to="/onboarding" icon="🎓" label="Student Onboarding" />
            <L to="/admin-messages" icon="📨" label="Message Admin" />
          </>
        )}

        {(role === 'hr' || role === 'super_admin') && (
          <>
            {role === 'hr' && <L to="/hr/dashboard" icon="▦" label="Dashboard" />}
            {role === 'super_admin' && <L to="/admin/dashboard" icon="▦" label="Dashboard" />}
            {role === 'super_admin' && <L to="/hr/dashboard" icon="📊" label="HR Dashboard" />}
            <L to="/employee/tasks" icon="📝" label="My Tasks" />
            <L to="/hr/tasks" icon="✓" label="All Tasks" />
            <L to="/hr/tasks/assign" icon="+" label="Assign Task" />
            <L to="/hr/employees" icon="👥" label="Employees" />
            <L to="/hr/issues" icon="⚠" label="Issues" />
            <L to="/hr/concerns" icon="✉" label="Concerns" />
            <L to="/hr/leaves" icon="📅" label="Leave Requests" />
            <L to="/hr/meetings" icon="📆" label="Weekly Meetings" />
            <L to="/employee/feedback" icon="💬" label="Feedback" />
            <L to="/onboarding" icon="🎓" label="Student Onboarding" />
          </>
        )}

        {role === 'super_admin' && (
          <>
            <div className="sidebar-divider" />
            <L to="/admin/users" icon="🔑" label="User Management" />
            <L to="/admin/users/new" icon="👤" label="Create User" />
            <L to="/admin/activity-log" icon="📜" label="Activity Log" />
            <L to="/admin/vault" icon="🔐" label="Password Bank" />
            <L to="/admin-messages" icon="📨" label="Employee Messages" />
          </>
        )}

        <div className="sidebar-divider" />
        <L to="/chat" icon="💭" label="Chat" />
        <L to="/expenses" icon="🧾" label="Expenses" />
        <L to="/vault" icon="🔑" label="My Passwords" />
        <L to="/documents" icon="📚" label="Company Documents" />
        <L to="/notifications" icon="🔔" label="Notifications" />
      </nav>
    </aside>
  );
}
